import { render, staticRenderFns } from "./OperationSubsidyInactiveScore.vue?vue&type=template&id=34a73436&scoped=true&"
import script from "./OperationSubsidyInactiveScore.vue?vue&type=script&lang=js&"
export * from "./OperationSubsidyInactiveScore.vue?vue&type=script&lang=js&"
import style0 from "./OperationSubsidyInactiveScore.vue?vue&type=style&index=0&id=34a73436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a73436",
  null
  
)

export default component.exports